import React, { Component } from 'react';
import { PlusOutlined, SettingOutlined, ExportOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Input, Space, Tag, Divider } from 'antd';
import { ProTable } from '@ant-design/pro-components';
import './style.css';
import TextFilter from './components/TextFilter';
import NumberFilter from './components/NumberFilter';
import TreeFilter from './components/TreeFilter';
import EnumFilter from './components/EnumFilter';
import DateFilter from './components/DateFilter';
import moment from 'moment';
import { cloneDeep } from 'lodash'

const { Search } = Input;

class GrtTable extends Component {
  constructor() {
    super();
    this.actionRef = React.createRef();
  }

  state = {
    searchForm: {},
    columnsStateMap: {}, //TODO:初始值需要改
  };

  handleSearch = (params) => {
    let condition = this.state.searchForm.condition
    if (condition && condition.length) {
      let index = condition.findIndex(v => v.column_name === params.column_name)
      if (index > -1) {
        condition.splice(index, 1, params)
      } else {
        condition.push(params)
      }

    } else {
      condition = [{ ...params }]
    }

    this.setState({
      searchForm: { ...this.state.searchForm, condition },
    });
    this.actionRef.current.reload({ resetPageIndex: true });
  };

  tagClosed = (e, item) => {
    let condition = this.state.searchForm.condition.filter(v => v.column_name !== item.column_name)
    this.setState({
      searchForm: { ...this.state.searchForm, condition },
    }, () => {
      console.log(this.state.searchForm)
    });
    this.actionRef.current.reload({ resetPageIndex: true });
  };

  setFilteredValue = (condition, item) => {
    if (condition && condition.length) {
      let obj = condition.find(v => v.column_name === item.dataIndex);
      if (obj) {
        if (obj.type === 'tree') {
          item.checkedNodesTitle = obj.checkedNodesTitle
        }
        if (obj.type === 'date') {
          if (obj && obj.values && obj.values.length) {
            const [startTime, endTime] = obj.values || [];
            item.filteredValue = [moment(startTime / 1), moment(endTime / 1)]
          } else {
            item.filteredValue = []
          }
        } else {
          item.filteredValue = obj.values
        }
        return item
      }
    }
    item.filteredValue = null
    item.checkedNodesTitle = null
    return item
  }

  getColumns = (columns) => {
    let new_columns = cloneDeep(columns);
    new_columns.forEach((item) => {
      switch (item.filterType) {
        case 'text':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), TextFilter(item, this.handleSearch));
          break;
        case 'vague':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), TextFilter(item, this.handleSearch, 'vague'));
          break;
        case 'number':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), NumberFilter(item, this.handleSearch));
          break;
        case 'tree':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), TreeFilter(item, this.handleSearch, item.options, item));
          break;
        case 'enum':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), EnumFilter(item, this.handleSearch, item.options));

          if (!item.render) {
            item.render = (text) => {
              let label;
              if (item.options && item.options.length) {
                item.options.forEach(v => {
                  if (v.value === text) label = v.label
                })
              }
              return label
            }
          }
          break;
        case 'date':
          item = Object.assign(this.setFilteredValue(this.state.searchForm.condition, item), DateFilter(item, this.handleSearch));
          break;
      }
    });
    return new_columns;
  };
  setColumnsStateMap = (value) => {
    this.setState({
      columnsStateMap: value,
    });
  };
  onSearch = (value) => {
    this.setState(
      {
        searchForm: Object.assign(this.state.searchForm, { key_word: value }),
      },
      () => {
        this.actionRef.current.reload({ resetPageIndex: true });
      },
    );
  };

  reload = () => {
    this.actionRef.current.reload()
  }

  getRelevantValue = (item) => {
    switch (item.type) {
      case 'date':
        return `${item.column_text} = ${moment(item.values[0] / 1).format('YYYY-MM-DD')}-${moment(item.values[1] / 1).format('YYYY-MM-DD')}`
        break;
      case 'enum':
        return `${item.column_text} = ${item.enumTextAry}`
        break
      case 'tree':
        return `${item.column_text} = ${item.checkedNodesTitle}`
        break
      case 'text' || 'number':
        return `${item.column_text} = ${item.values}`
        break
      default:
        return `${item.column_text} = ${item.values}`
    }
  }
  render() {
    let { searchForm, columnsStateMap } = this.state;
    let { options } = this.props;
    return (
      <ProTable
        key={true}
        rowKey={this.props.rowKey}
        columns={this.getColumns(this.props.columns)}
        actionRef={this.actionRef}
        search={false}
        pagination={{
          page_size: 10,
        }}
        request={(params = {}, sort) => {
          let sortCopy = cloneDeep(sort)
          if (sortCopy && Object.keys(sortCopy).length) {
            Object.keys(sortCopy).forEach(v => {
              sortCopy[v] = sortCopy[v] === 'ascend'
            })
          }
          return this.props.request(
            Object.assign({}, searchForm, {
              page_num: params.current,
              page_size: params.pageSize,
              sorter: sortCopy,
            }),
          )
        }

        }
        headerTitle={
          <Space>
            {options?.search ? <Search style={{ width: 200 }} onSearch={this.onSearch} /> : null}

            {
              searchForm.condition && searchForm.condition.length ? searchForm.condition.map((item) => {
                if (item.values && item.values.length) {
                  //array类型
                  return (
                    <Tag
                      closable
                      key={item.column_name}
                      onClose={(e) => {
                        this.tagClosed(e, item);
                      }}
                    >
                      {this.getRelevantValue(item)}
                    </Tag>
                  );
                }
              }) : null
            }
          </Space>
        }
        toolBarRender={() => [
          <Space>
            {options?.export ? (
              <Button
                key="4"
                style={{ border: 'none', boxShadow: 'none' }}
                onClick={() => {
                  this.props.onExport(columnsStateMap);
                }}
              >
                <ExportOutlined style={{ fontSize: '16px' }} />
                导出
              </Button>
            ) : null}

            {options?.reload ? (
              <Button
                key="5"
                style={{ border: 'none', boxShadow: 'none' }}
                onClick={() => {
                  this.actionRef.current.reload();
                }}
              >
                <ReloadOutlined style={{ fontSize: '16px' }} />
                刷新
              </Button>
            ) : null}

            <Divider type="vertical" style={{ height: 22 }} />

            {options?.created ? (
              <Button
                key="3"
                type="primary"
                onClick={() => {
                  this.props.onCreated();
                }}
              >
                <PlusOutlined />
                创建
              </Button>
            ) : null}
          </Space>,
        ]}
        options={{
          reload: false,
          setting: options?.setting
            ? {
              children: (
                <Space>
                  <SettingOutlined />
                  <span style={{ fontSize: '14px' }}>设置</span>
                </Space>
              ),
            }
            : null,
          density: false,
        }}
        columnsState={{
          value: columnsStateMap,
          onChange: this.setColumnsStateMap,
        }}
      />
    );
  }
}

export default GrtTable;
